import { SVGProps } from "react";

function SvgComponent(props: SVGProps<SVGSVGElement>) {
  return <svg
    width="70"
    height="70"
    viewBox="0 0 70 70"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_4845_28561)">
      <circle cx="35" cy="33" r="25" fill="white" />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M46.5764 33.1562C46.5764 32.2787 46.4982 31.435 46.353 30.625H34.7839V35.4119H41.3948C41.1101 36.9587 40.2446 38.2694 38.9437 39.1469V42.2519H42.9136C45.2363 40.0975 46.5764 36.925 46.5764 33.1562Z"
      fill="#4285F4"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M34.7839 45.2498C38.1005 45.2498 40.8811 44.1417 42.9135 42.2517L38.9436 39.1467C37.8437 39.8892 36.4366 40.3279 34.7839 40.3279C31.5845 40.3279 28.8765 38.1511 27.9105 35.2261H23.8066V38.4323C25.8279 42.4767 29.982 45.2498 34.7839 45.2498Z"
      fill="#34A853"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M27.9104 35.2261C27.6648 34.4836 27.5252 33.6905 27.5252 32.8749C27.5252 32.0593 27.6648 31.2661 27.9104 30.5236V27.3174H23.8065C22.9746 28.988 22.5 30.878 22.5 32.8749C22.5 34.8718 22.9746 36.7618 23.8065 38.4324L27.9104 35.2261Z"
      fill="#FBBC05"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M39.4796 27.2725L43.0028 23.7231C40.8755 21.7262 38.0949 20.5 34.7839 20.5C29.982 20.5 25.8279 23.2731 23.8066 27.3175L27.9105 30.5237C28.8765 27.5987 31.5845 25.4219 34.7839 25.4219C36.5874 25.4219 38.2066 26.0462 39.4796 27.2725Z"
      fill="#EA4335"
    />
    <defs>
      <filter
        id="filter0_d_4845_28561"
        x="0"
        y="0"
        width="70"
        height="70"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_4845_28561"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_4845_28561"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
}

export default SvgComponent;
